import { Box, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { CenterReportGathering } from '@/module/Laboratory/CenterReportGathering';
import { getCenterLastReportOptions } from '@/module/ResearchCenter';

import { Id } from '@feature/utils';

export function CenterReport({ labId }: { labId: Id }) {
  const { data } = useSuspenseQuery(getCenterLastReportOptions());
  const { t } = useTranslation();

  return (
    <Box>
      {data.open && <CenterReportGathering labId={labId} />}
      {!data.open && <Text fs="italic">{t('labs.reportClosed')}</Text>}
    </Box>
  );
}
